import { Component } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { appInjector } from '../app-injector';
import { BaseComponent } from '../base-component';
import { ShipmentDetailStatus } from '../enums/shipmentdetail-status.enum';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-multiple-pieces-modal',
  templateUrl: './multiple-pieces-modal.component.html',
  styleUrl: './multiple-pieces-modal.component.css'
})
export class MultiplePiecesModalComponent extends BaseComponent {
  constructor(
    private langService: LanguageService,
    public modal: BsModalRef,
  ) {
    super();
  }

  bultos: any;
  ShipmentDetailStatus = ShipmentDetailStatus;

  async search() {
    try {
      await this.sesion.searchExpedition(this.sesion.numeroExpedicionBuscado);
      this.modal.hide();
    } catch (err) {
      ErrorModalComponent.show(err);
    }
  }

  static show(params?: ModalOptions<MultiplePiecesModalComponent>) {
    const modalService = appInjector.get(BsModalService);
    modalService.show(MultiplePiecesModalComponent, params);
  }
  textoStatus(bulto: { Status: ShipmentDetailStatus, Origin: string, Destination: string }): string {
    switch (bulto.Status) {
      case ShipmentDetailStatus.InformationReceived:
        return this.langService.instant('Shared.ProgressReadyAtDHL') + ' ' + bulto.Origin;
      case ShipmentDetailStatus.InTransit:
        return this.langService.instant('Shared.ProgressInTransit');
      case ShipmentDetailStatus.InDestinationAgency:
        return this.langService.instant('Shared.ProgressReadyAtDHL') + ' ' + bulto.Destination;
      case ShipmentDetailStatus.Assigned:
        return this.langService.instant('Shared.ProgressOutForDelivery');
      case ShipmentDetailStatus.InServicePoint:
        return this.langService.instant('Shared.ProgressPickUpServicePoint');
      case ShipmentDetailStatus.RetryDelivery:
        return this.langService.instant('Shared.ProgressRetryDelivery');
      case ShipmentDetailStatus.Delivered:
        return this.langService.instant('Shared.ProgressDelivered');
      case ShipmentDetailStatus.Returned:
        return this.langService.instant('Shared.ProgressUndeliveredParcel');
    }
  }
}
